import React, { useState, useEffect, useCallback } from 'react';
import '../styles/Carousel.css';

const slides = [
  {
    image: '/28ef.jpg',
    title: 'Путешествуйте с комфортом!',
    description: 'Арендуйте автомобиль своей мечты уже сегодня!',
    buttonText: 'Забронировать сейчас',
    buttonLink: '/cars',
  },
  {
    image: '/7fbb.jpg',
    title: 'Городской стиль — ваш выбор!',
    description: 'Для деловых встреч или прогулок по городу. Аренда авто от 1600 рублей в день!',
    buttonText: 'Выбрать авто',
    buttonLink: '/cars',
  },
  {
    image: '/559b.jpg',
    title: 'Дольше аренда – меньше стоимость!',
    description: 'Исследуйте мир на авто. Гибкие условия аренды. Скидка на аренду авто!',
    buttonText: 'Получить скидку',
    buttonLink: '/cars',
  },
];

const Carousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  }, [slides.length]);

  const prevSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  }, [slides.length]);

  const goToSlide = useCallback((index) => {
    setCurrentSlide(index);
  }, []);

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, [nextSlide]);

  return (
    <section className="container section">
      <div className="carousel">
        <div
          className="slide-container"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {slides.map((slide) => (
            <div className="slide" key={slide.image}>
              <img
                src={slide.image}
                alt={slide.title}
                className="slide-img"
                loading="lazy"
              />
              <div className="overlay">
                <h2>{slide.title}</h2>
                <p>{slide.description}</p>
                <a href={slide.buttonLink} className="btn">
                  {slide.buttonText}
                </a>
              </div>
            </div>
          ))}
        </div>
        <button
          className="carousel-btn carousel-btn-prev"
          onClick={prevSlide}
          aria-label="Предыдущий слайд"
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        <button
          className="carousel-btn carousel-btn-next"
          onClick={nextSlide}
          aria-label="Следующий слайд"
        >
          <i className="fas fa-chevron-right"></i>
        </button>
        <div className="carousel-indicators">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`indicator ${currentSlide === index ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Слайд ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Carousel;